import React, { useEffect } from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  useEffect(() => {
    document.title = "T&C | Mango Holidays";
  }, []);

  // Print Handler: UI/UX Optimized for A4 Paper with Strict Page Breaks
  const handlePrint = () => {
    const printWindow = window.open("", "", "height=900,width=800");
    const termsContent = document.getElementById(
      "terms-content-to-print",
    ).innerHTML;
    const origin = window.location.origin;

    printWindow.document.write(`
      <html>
        <head>
          <title>Terms and Conditions | Mango Holidays</title>
          <style>
            /* --- BASE PRINT TYPOGRAPHY --- */
            body {
              font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
              font-size: 12pt; /* Increased font size for better print readability */
              color: #222;
              line-height: 1.6;
              margin: 0;
              padding: 0;
              background: #fff;
            }

            /* --- A4 PAGE SETUP --- */
            @page {
              size: A4 portrait;
              margin: 25mm 20mm 30mm 20mm; /* Top, Right, Bottom (extra room for footer), Left */
            }

            /* Prevent lonely lines at the top/bottom of pages */
            p, li, div, td, th {
              orphans: 3;
              widows: 3;
            }

            /* --- HEADER (Repeats at top of first page only) --- */
            .print-header {
              text-align: center;
              border-bottom: 3px solid #d35400;
              padding-bottom: 15px;
              margin-bottom: 30px;
            }
            .print-header img {
              height: 60px; 
              width: auto;
              margin-bottom: 12px;
            }
            .print-header h1 {
              margin: 0;
              color: #111; /* Darker for print contrast */
              font-size: 22pt;
              font-weight: 800; /* Bolded Heading */
              text-transform: uppercase;
              letter-spacing: 1px;
            }

            /* --- REPEATING PAGE FOOTER --- */
            .print-footer {
              position: fixed;
              bottom: 0;
              left: 0;
              right: 0;
              text-align: center;
              font-size: 10pt;
              font-weight: bold;
              color: #555;
              border-top: 1px solid #ddd;
              padding-top: 10px;
            }

            /* --- CONTENT HIERARCHY & NUMBERING --- */
            .terms-list {
              list-style-type: none;
              counter-reset: terms-counter;
              padding-left: 0;
              margin: 0;
            }
            
            /* CRITICAL: page-break-inside avoid prevents the item from being cut in half */
            .terms-list > li {
              position: relative;
              padding-left: 40px; 
              margin-bottom: 18px; /* Increased spacing */
              text-align: justify;
              page-break-inside: avoid; 
            }

            /* Auto-generate legal numbers (1., 2., 3.) */
            .terms-list > li::before {
              counter-increment: terms-counter;
              content: counter(terms-counter) ".";
              position: absolute;
              left: 0;
              top: 0;
              font-weight: bold;
              font-size: 13pt; /* Slightly larger numbers */
              color: #d35400;
            }

            /* --- CALLOUT BLOCKS (Subtext) --- */
            .subtext {
              font-style: italic;
              margin: 25px 0 25px 40px; 
              padding: 15px 20px;
              background-color: #f5f5f5 !important;
              border-left: 4px solid #d35400;
              font-size: 11pt;
              color: #333;
              text-align: justify;
              page-break-inside: avoid; /* Keep boxes whole on one page */
            }
            
            /* --- DATA TABLES --- */
            .table-container {
              margin: 30px 0 30px 40px; 
              page-break-inside: avoid; /* Keep table on one page if possible */
            }
            .policy-table {
              width: 100%;
              border-collapse: collapse;
              font-size: 11pt;
            }
            .policy-table th, .policy-table td {
              border: 1px solid #999;
              padding: 12px;
              text-align: left;
              vertical-align: middle;
            }
            .policy-table th {
              background-color: #eee !important;
              color: #111;
              font-weight: bold;
            }

            /* --- PRINT FORCING --- */
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-header">
            <img src="${origin}/img/logo.webp" alt="Mango Holidays" onerror="this.style.display='none'" />
            <h1>Official Terms & Conditions</h1>
          </div>
          
          <div class="print-footer">
            Mango Holidays (India) Pvt. Ltd. | Official Terms and Conditions Document
          </div>

          ${termsContent}
        </body>
      </html>
    `);

    printWindow.document.close();

    setTimeout(() => {
      printWindow.print();
    }, 500);
  };

  return (
    <>
      {/* -- Banner Section -- */}
      <section className="banner-section-terms">
        <div className="img-container-terms">
          <img src="/img/about-us-banner.webp" alt="Banner" />
        </div>
        <div className="banner-overlay-terms" />
      </section>

      {/* -- Terms & Conditions Section -- */}
      <section className="terms-container">
        {/* Bolded and increased size for the main screen heading */}
        <h1 className="title">MANGO HOLIDAYS - TERMS & CONDITIONS</h1>

        {/* --- PRINT CONTAINER --- */}
        <div id="terms-content-to-print">
          <ul className="terms-list">
            <li>
              You / Passenger / Guest / Client / Customer means the person/s in
              whose name and / or whose behalf the booking is made and / or
              whose name appears on the booking form, invoices and includes
              every person availing the services of Mango Holidays (India) Pvt.
              Ltd.
            </li>
            <li>
              We / Us / Our / MHIPL / Mango Holidays refers to Mango Holidays
              (India) Pvt. Ltd.
            </li>
            <li>Infant means a person below the age of two years.</li>
            <li>
              Child means a person from the age of two and below the age of
              twelve years.
            </li>

            <div className="subtext">
              Mango Holidays (India) Pvt. Ltd. (MHIPL) is a Tour Operator. Mango
              Holidays (India) Pvt. Ltd. do not own / operate or control Hotels,
              Railways, Buses, Taxis, Passenger Cars, Cable Cars, Trams,
              Airlines, Caterers, Restaurants, Places of sightseeing and
              entertainment like theme parks, Museums, Art galleries, Shopping
              Malls, Railway, Ferry, Cruise, Coach, Guides, Insurance Providers,
              all sightseeing attractions companies etc. who are to provide the
              services to the Client. MHIPL is only a tour operator and it only
              help you in organizing different 3rd party services for your
              holidays like Visas from Consulate or Air Tickets from Airlines or
              Car from Rental Car Services or Accommodation from Hotels or
              Travel Insurance from the Companies or Transfers from Coach
              Companies or Food from the Restaurants. MHIPL has no control over
              the services offered by them. Therefore, MHIPL is not liable for
              any deficiency that you may have in the services offered by such
              or similar 3rd party suppliers.
            </div>

            <li>
              The terms and conditions specified by those service providers,
              including their payment schedule, cancellation; refund etc. shall
              be applicable, in addition to our terms and conditions mentioned
              herein. The services comprising the tours are provided by
              independent entities. Although we select reputed suppliers, Mango
              Holidays (India) Pvt. Ltd. or their staff has no direct control
              over such services or persons providing such services. MHIPL
              cannot be held responsible if the supplier does not provide the
              contemplated service or there is a defect or deficiency in the
              services provided by the supplier.
            </li>
            <li>
              Our Brochure / Itineraries / Programs / Advertisements / Website
              are printed / published several months in advance and Mango
              Holidays (India) Pvt. Ltd. makes every effort to ensure the
              accuracy of the information during publication. Mango Holidays
              (India) Pvt. Ltd. reserves unconditional rights to change any
              brochure website information before or after the tour is booked
              due to occurrence of any event beyond our control including but
              not limited to change in government policy or local authority of
              any particular country, statutory restrictions, medical emergency,
              restrictions due to pandemic / epidemic etc.
            </li>
            <li>
              The maps used in the brochures are inserted solely for
              illustrations and are not to the scale. Photographs of meals and
              sightseeing printed in the brochures / website / advertisements
              are for reference only and may differ from the actual meals
              served/ sights seen.
            </li>
            <li>
              Mango Holidays (India) Pvt. Ltd. reserves unconditional rights to
              change/ alter/ amend the final itineraries, tour prices, departure
              dates, airline Sightseeing Attractions, Hotels, Restaurants, Coach
              Companies, Guide Services and any other tour related service or
              service provider without any prior notice. If we are aware of
              these changes sufficiently beforehand, we will definitely inform
              you in advance, otherwise our tour escort or local representative
              will inform you of the changes on tour. In case the alternative
              arrangement or services made are materially superior as compared
              to the one described, we may charge extra for the same. Mango
              Holidays (India) Pvt. Ltd. reserves this particular unconditional
              right due to various reasons including but not limited to airline
              going bankrupt or flight cancellations or change of flight
              schedules after the booking is done etc.
            </li>
            <li>
              We at MHIPL are committed to deliver whatever is promised to you,
              but due to the circumstances beyond our control like heavy
              traffic, traffic jam, taxi / bus / passenger car breakdown,
              delayed flights, flight cancellations, missed connections, long
              lines, less day light, bad weather conditions, border or police
              checks, coach break down, accidents, VIP movement, riots, strikes,
              extremist attacks, festivals, earth quake, fire, war, volcanic
              ash, religious rituals, heavy snow fall, airport closure or any
              other reason whatsoever, if you miss any sightseeing or if you get
              less time to cover any museum or any sightseeing then MHIPL is not
              responsible or liable for the same. Further if the flights are
              cancelled or you are unable to reach in time to board the flight
              due to any reason then the expenses for fresh flight bookings are
              to be borne by you only. However if MHIPL pays for the same then
              you shall be required to pay / reimburse the same to MHIPL within
              48 hours from the date of arrival in India (in case of
              international tours) or last date of tour (in case of domestic
              tours).
            </li>
            <li>
              Mango Holidays (India) Pvt. Ltd. recommends that, not more than
              three persons share a room. A triple room is normally of the same
              size as a double room. In case of triple room, the third bed is
              usually a roll away bed or folding cot.
            </li>
            <li>
              As the client would be out sightseeing most of the time and retire
              to the room only for the night, Mango Holidays (India) Pvt. Ltd.
              selects hotels at locations, which give comfort and value for
              money. Hence depending on the day to day itinerary, the hotel may
              be confirmed either in the city or away from the city centre. Some
              hotels do not have air conditioners, room heaters or fans. Double
              rooms in Europe are comparatively small and single rooms are even
              smaller. A double room has either a single queen-size bed or two
              separate beds. If the client requests for a room with queen-size
              bed, the same would be provided subject to availability as
              majority of the hotels in Europe have twin bedded rooms. In case
              of non-availability of room with queen-size bed, a twin
              bedded-room would be given. If the client want to change / upgrade
              the room, then the client has to bear extra charges for the same
              and that too will also depend upon the availability of the room.
            </li>
            <li>
              A child for whom “without bed” charge has been paid would not be
              entitled to a separate bed in the hotel. In case “with bed”
              ‘charge has been paid for the child and client decide not to avail
              such facility whilst on the tour, he / she would not be entitled
              to any refund. In case client decides to seek extra bed on tour
              for the child booked on “without bed basis” then subject to
              availability, he / she shall be bound to pay additional amount
              charge to the concerned Hotel directly.
            </li>
            <li>
              In case of a request at the time of booking by the client for
              preference of nearby or inter connecting or adjoining rooms, Mango
              Holidays (India) Pvt. Ltd. would make every effort for the same,
              however as the Hotel management does rooms allocations, hence
              there is no assurance in this regard.
            </li>
            <li>
              The clients / customers will have to abide by the check in and
              check out times of the Hotels. In case of individual travels or in
              case of direct joining or direct leaving passengers the client
              should themselves manage early arrivals and late departures. In
              case the client fails to abode by the check out timings of the
              hotel and the hotel management charges any extra amount for the
              same then the client has to bear such extra amount.
            </li>
            <li>
              The average travelling time by coach can be approximately 8 hours
              a day under normal road conditions. Comfort stops are provided
              after appropriate intervals having regard to the daily itinerary
              and therefore, though some of the coaches are equipped with
              emergency washrooms, such facility can be used only in case of an
              emergency. If the client is having any medical problem due to
              which he has to visit the wash room / rest room frequently then
              the client has to disclose such fact in writing at the time of
              booking itself. If the client fails to inform the same then no
              such instructions can be given to the service provider at the
              eleventh hour. If the service provider agrees to take such haults
              by charging some extra amount then such extra amount has to be
              borne by the client.
            </li>
            <li>
              Smoking, consumption of alcoholic beverages, ice creams, chewing
              gum and snacks is strictly prohibited on coaches, taxis, buses,
              passenger cars etc. and also at the places of sightseeing’s. If
              any fine is imposed / levied on the client due to such acts then
              the client shall bear the same.
            </li>
            <li>
              The clients should not leave behind any personal item / property
              in the coach / car, while disembarking the coach. Mango Holidays
              (India) Pvt. Ltd. will not be responsible or liable in case of
              loss of any personal item or any such property either in the
              coach, car, hotel, any sightseeing place, flight, taxi, cable car,
              cruise, ferry, train, tram or restaurants under any circumstances.
            </li>
            <li>
              No seats are reserved except the first two seats for the tour
              manager. We find it fair to enforce daily seats rotation. Please
              adhere to the instructions given by the tour manager in this
              regard.
            </li>
            <li>
              As per the law in many countries, it is mandatory to wear a seat
              belt in the coach. If the client is not wearing the same, he/she
              may have to pay a fine to the police / local authorities. Any
              damage or loss done to you during the travel by coach because you
              were not wearing a seatbelt is not covered by your travel
              insurance.
            </li>
            <li>
              Any damage caused by you to the coach, car, taxi, hotel, cruise,
              ferries, trains, restaurants for any reason whatsoever, shall be
              payable by you to the respective service provider. Mango Holidays
              (India) Pvt. Ltd. will not be liable for the same.
            </li>
            <li>
              Meals provided by Restaurants / Hotels are as per menu. Mango
              Holidays (India) Pvt. Ltd., however reserves the right to change
              the meal arrangement, if circumstances make it necessary to do so.
            </li>
            <li>
              Mango Holidays (India) Pvt. Ltd. cannot assure special meal or
              diet for the Client / Customer. If the Client misses or refrains
              from availing any meal arranged by Mango Holidays (India) Pvt.
              Ltd. due to any reasons whatsoever, there would be no refund, for
              the same. Even though MHIPL asks for food preference at the time
              of booking however it cannot assure about the same. At no point of
              time MHIPL makes / has made any commitment about providing of any
              such special meal. Further the client has to ask in the hotels,
              airlines, cruise etc. and needs to enquire with the concerned
              staff, chef etc. about the ingredients used in the meal.
            </li>
            <li>
              The Client / Customer travelling by Air would be subject to the
              Airline restrictions or limitations on baggage weight/ size /
              number. As porterage is not included in the tour price and due to
              limited space for luggage in the coach, it is recommended that the
              Client should carry one single suitcase per person, preferably
              with wheels for sake of convenience. Airline may charge extra for
              bags more than specific weight. Such additional charges will be
              borne directly by client / customer. The client should check for
              permissible baggage limit on his air ticket before packing and
              travelling.
            </li>
            <li>
              All baggage and personal effects are at all times and in all
              circumstances the responsibility of the Client/Customer. Mango
              Holidays (India) Pvt. Ltd. shall not be liable for the loss or the
              delay or theft or damage of baggage by Trains / Airline / Hotel/
              Cruise/ Coach/ Coach driver/ Porters or any other carrier or
              service provider.
            </li>
            <li>
              It is strongly advised to Clients / Customers not to carry any
              valuables on tour. However, if the Client carries any valuables,
              the same should be in his / her custody all the time or may be
              kept in the safe deposit lockers, that are commonly made available
              in most of the Hotels. Deposit amount and charges for such safe
              deposit lockers is to be borne by the client. However, Mango
              Holidays (India) Pvt. Ltd. will not be responsible for loss of
              valuables or for making good any such loss.
            </li>
            <li>
              Tipping is customary (unless otherwise stated in the itinerary or
              pricing) in all parts of the world for services rendered (e.g.
              porters, coach drivers, guides etc.) your tour manager may guide
              you in this regard.
            </li>
            <li>
              Your passport is the official document that is mandatory for every
              Client/ Customer to travel abroad. The customer should ensure that
              passport is valid at least six months after the last date of the
              intended tour. Customer should also ensure that, their passports
              have sufficient blank pages for obtaining the required visas. In
              case you are obtaining visa, please ensure that your passport is
              issued not more than ten years ago and that your passport has the
              correct date of birth, photo, sex, address and the printed
              passport number matches with the perforated passport number. It is
              the customer’s responsibility to ensure that the passport is not
              damaged or stained.
            </li>
            <li>
              In case of loss/ theft/ damage of passport while on tour, all
              expenses like Airfare, Hotel accommodation, transportation, meals
              or any other such or similar expenses along with costs incurred
              towards issuance of the new duplicate passport or emergency
              departure card or any other required documentation is the sole
              responsibility of the Client and will be borne by the Client
              themselves. Mango Holidays (India) Pvt. Ltd. will not be
              responsible/ liable for the same. In such event a tour manager
              will not stay with the client as he has to continue the tour as
              per the itinerary and as also having responsibility of other
              clients in the tour. Further if the passport of the client is lost
              / stolen / damaged and for completing further formalities any of
              his family member / friend decides to stay with the client to
              accompany then his expenses shall also be borne by that particular
              individual only and not by MHIPL.
            </li>
            <li>
              It is entirely the responsibility of the Client or Customer to
              arrange, provide and carry on tour valid travel documents
              including passport with necessary valid Visas and immigration
              clearance (if applicable), sufficient Foreign exchange, confirmed
              Air tickets, documents confirming insurance to cover risk to life,
              limb and property for the duration of the tour, medical
              clearances, inoculations/ vaccination certificates as the case may
              be to be able to travel as per the tour itinerary.
            </li>
            <li>
              It is the Client’s/ Customer’s responsibility to collect in time
              the necessary travel documents submitted to Mango Holidays (India)
              Pvt. Ltd. from its registered office.
            </li>
            <li>
              Though the Airline tickets for the Client / Customer issued for
              the particular sector may have confirmed status, but due to over
              booking of seats, flights getting delayed / postponed / cancelled
              due to technical problems or any other reasons whatsoever, the
              airline may offload any passengers and accommodate him / her on a
              subsequent flight for which Mango Holidays (India) Pvt. Ltd. will
              not be responsible or liable. Also due to this if Client/ Customer
              misses his or her connecting flights or any sightseeing then MHIPL
              will not be responsible or liable for the same.
            </li>
            <li>
              If a Client/customer on any tour wants to start or return on a
              different date/ time / airline other than those selected by Mango
              Holidays (India) Pvt. Ltd. for the tour, it shall be solely the
              responsibility of that Client to purchase Air tickets on their own
              and Mango Holidays (India) Pvt. Ltd. will not be responsible or
              liable to refund airfare amount taken as a part of the tour
              package. It is a sole responsibility of every client / customer to
              reconfirm his / her Air tickets 72 hours prior to the date of
              departure and make his or her own arrangement to reach the hotel
              from airport and to reach the airport from hotel.
            </li>
            <li>
              It may be noted that the tour cost does not include the insurance
              premium (unless mentioned otherwise), and that the clients shall
              have to acquire the same at their cost.
            </li>
            <li>
              The settlement of the insurance claim is solely at the discretion
              of the insurance company. Mango Holidays (India) Pvt. Ltd. cannot
              influence the decision on the same.
            </li>
            <li>
              As insurance is a contract between the insurance agent and client,
              Mango Holidays (India) Pvt. Ltd is not liable towards any claim or
              rejection of claim arising out of such contract. Mango Holidays
              (India) Pvt. Ltd is not liable to pay for any service other than
              that mentioned in tour itinerary and agreed upon by both parties.
            </li>

            <div className="subtext">
              If the tour or any part thereof cannot be conducted due to Force
              Majeure or Vis Majeure including but not limited to war, terrorist
              attack, threats of terrorism, disease, pandemic, epidemic,
              government restrictions, local authority restrictions, curfew,
              strike, revolution, civil disorders, disruptions, fire, natural
              disasters that fall under the ‘act of god’ category such as a
              flood, earthquake, landslides or hurricane Mango Holidays (India)
              Pvt. Ltd. shall not be responsible to give any refund to the
              Client as MHIPL has to pay to the suppliers, service providers
              well in advance without which a tour cannot be planned /
              organized. Further if the tour or any part of the tour is not
              taking place due to any situation which is Force Majeure like
              Pandemic, Epidemic, Any Natural Calamity, Airlines' Pilots or
              Airlines' Employees on strike, Airport Closure, Heavy Snowfall,
              Heavy Rains, Fogg, War, Political unrest, Religious unrest,
              Earthquake, Volcano Eruption or Flying Volcanic ash, Storm,
              Weather, Riots, Coronation, Extremist Attacks, Death of any famous
              personality, Lock Down, Quarantine Measures, Monument under
              repairs or maintenance, VIP Movement, Police Cordon off the area,
              Firing, Accidents, Military Action, Traffic Jams, Road Blockage,
              employees of any concerned services on strike then MHIPL is not
              liable to refund or compensate for any unveiled services.
            </div>

            <li>
              As MHIPL book services in advance and are bound to honor the
              commitments with respect to payment to the suppliers, service
              providers in advance.
            </li>
            <li>
              If the client wants to cancel the tour, he / she must intimate
              Mango Holidays (India) Pvt. Ltd. in writing or on mail to us at
              our office address on working days within office time. If one or
              more persons have signed the booking form for themselves and for
              others mentioned in the form, communication signed by such
              signatories would be treated as valid communication and shall
              commence only from the time the written request reaches the Mango
              Holidays (India) Pvt. Ltd. office on working days within office
              time. In case of cancellation, the following cancellation charges
              would apply and the client is entitled to get the refund of the
              amount after deducting the cancellation charges as mentioned
              hereunder.
            </li>

            <div className="table-container">
              <table className="policy-table" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>WHEN A CANCELLATION IS MADE</th>
                    <th>
                      CANCELLATION CHARGES PER PERSON i.e AN AMOUNT WHICH THE
                      CLIENT IS NOT ENTITLED TO GET BACK
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      Clear 45 working days or more prior to the date of
                      departure of the tour.
                    </td>
                    <td>BOOKING AMOUNT</td>
                  </tr>
                  <tr>
                    <td>
                      Clear 44 to 30 working days prior to the date of departure
                      of the tour.
                    </td>
                    <td>70% of the tour cost</td>
                  </tr>
                  <tr>
                    <td>
                      Clear 29 to 16 working days prior to the date of departure
                      of the tour.
                    </td>
                    <td>80% of the tour cost</td>
                  </tr>
                  <tr>
                    <td>
                      Less than 15 clear working days (Including 15th day) prior
                      to the date of departure of the tour.
                    </td>
                    <td>100% of the tour cost</td>
                  </tr>
                  <tr>
                    <td>If the client does not show up on the tour.</td>
                    <td>100% of the tour cost</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <li>
              In addition to above, in case of cancellation of tour by either
              party, the amount spent by Mango Holidays (India) Pvt. Ltd. on
              visas, travel insurance, POE, Air tickets including administrative
              charges would be payable by the client. If the total cancellation
              charges mentioned above exceeds the amount paid by the client, the
              balance amount would be payable by the client.
            </li>
            <li>
              In case of death of any client / customer after booking the tour
              and before the date of departure of the tour, the legal heir of
              the client / customer needs to submit the death certificate of the
              client / customer to Mango Holidays (India) Pvt. Ltd. along with
              letter of cancellation of the tour. The cancellation policy as
              mentioned above will be applicable in the event of death as well.
              The person claiming the refund for the tour booked by the now
              deceased client / customer has to attach declaration from the
              court regarding his / her status as a legal heir. Refund if any
              will be given as per the cancellation policy only to the legal
              heir as per the MHIPL’s satisfaction or as per the legal advice
              and that too by an account payee cheque.
            </li>
            <li>
              It is clearly understood that there shall be no refund whatsoever
              if the Client does not or cannot utilize any of the services like
              hotels, sightseeing, airlines and train booking/reservation,
              rides, cruises, meals, entrance fees, optional tours etc. due to
              any reason whatsoever.
            </li>
            <li>
              MHIPL reserves the right of sending messages on your mobile phones
              and/or email address to update you for various reasons like
              payments, visas, flights or similar. A mobile number and/or email
              address given and written on a booking form only shall be taken as
              a correct one and all communication made on such mobile number
              and/or email address shall be presumed to be received by you.
            </li>
            <li>
              A transfer from the originally booked tour to another tour will be
              treated as cancellation on the booked tour and a fresh booking on
              the other tour. All cancellation charges stated herein will apply.
              Tour price during the time of the fresh booking will be
              applicable. In case of such transfer the client will also loose
              the benefit of any discounts or promotional schemes in such event.
            </li>
            <li>
              Mango Holidays (India) Pvt. Ltd. shall not be responsible and / or
              liable for any loss, damages caused or to reimburse any expenses
              to the Client due to reasons beyond the control of Mango Holidays
              (India) Pvt. Ltd. (Force Majeure / Vis Majeure). Mango Holidays
              (India) Pvt. Ltd. shall, in no circumstances whatsoever be liable
              to pay to the Client for any loss, damages or reimburse the
              expenses in case of;
            </li>
            <li>
              Any loss of life, limb or property, sickness delay, discomfort,
              additional expenses incurred by the client, consequential loss
              and/or damage or any kind suffered by client howsoever cause
              arising out of any act, omission, default of any independent
              contractor or by any servant or agent employed by the independent
              contractor or third person who may be engaged or concern in the
              provision of accommodation, meals, transportation, entertainment,
              refreshment or any other service comprising the tour package.
            </li>
            <li>
              Temporary or permanent loss / damage to baggage / personal effects
              howsoever caused, which also includes willful negligence on the
              part of any person.
            </li>
            <li>
              Failure on the part of airline to accommodate passengers despite
              having confirmed tickets or cancellation or change of route or
              delay of flight or any other reason whatsoever.
            </li>
            <li>
              Any change in flight schedule or cancellation I delays of tour due
              to airlines going bankrupt, technical problem in aircraft, airline
              staff being on strike, airport closure, war, political or
              religious unrest, epidemics, meals not being served, any overstay
              expenses due to delay or changes in air, bus, ship, train or
              cancellation of special bogie or other services. Due to sickness,
              weather, earthquake, riots, fire, any natural calamities, any
              activities of nature, any extremist activities, or any other
              causes whatsoever and under such / similar situation arising on
              tour, any expenses incurred towards the hotel accommodations,
              meals, transfers, medicines, porterage and anything else of
              clients / customers will be borne by the Clients/customers
              themselves.
            </li>
            <li>
              Sightseeing missed or / and the program being curtailed after
              commencement of the tour and before the due period due to any
              unavoidable circumstances and any reasons beyond our control such
              as political causes, statutory restrictions, medical emergency,
              restrictions due to pandemic / epidemic, riots, strikes,
              disturbance, elections, curfew, threats, terrorist attack, natural
              calamity, monument under renovation, heavy rush at sightseeing
              places, public or national holidays, road traffic, congestion etc.
              All such loss/ expenses will be borne by the Client.
            </li>
            <li>
              If a client is unable to reach the place of commencement of the
              tour due to any reason whatsoever, his booking shall be treated as
              ‘no show’ on the tour and 100% cancellation charges would be
              levied. If a client avails pre-tour services or part thereof on
              the air ticket (cost of which is included in the main tour cost)
              but failed to join the tour at an appointed place, or cancels the
              tour after using the air tickets or pre- tour arrangements or part
              thereof, it shall be treated as ‘no show’ and there would be no
              refund whatsoever for any unutilized or main tour services.
            </li>
            <li>
              The custody and responsibility of passport, air tickets, all
              valuables and luggage will be with the individual client /
              customer. If it is lost, he/she has to bear all the expenses to
              get duplicate travel document/ s or duplicate air ticket/s. The
              tour leader will be available for your guidance only on group
              departures but it will not be mandatory for him/her to accompany
              the passenger/s for visits to Embassy / Police Station / Airline
              office / Hospital and so on. All expenses to get duplicate
              documents including fees and transport charges will be paid by the
              concerned Client. Mango Holidays (India) Pvt. Ltd. cannot be held
              liable for incidents beyond it’s control. MHIPL will not be
              responsible to pay / reimburse for any damages, loss or expenses
              borne by the client due to any accident, medical problems suffered
              during the tour, theft, personal liability etc. and such claims
              will not be entertained.
            </li>
            <li>
              Any dispute, controversy, or claim by or among the parties hereto
              arising out of or relating to or in connection with the
              transactions contemplated hereby or regarding tours, booking,
              including, without limitation, under this agreement or the
              organizational Documents, or the breach, termination or thereof (a
              “Dispute”) shall be a subject matter of Pune (Maharashtra) civil
              court’s jurisdiction only.
            </li>
            <li>
              The Client would have to strictly follow the Tour Program and
              return to India as per the validity of the air ticket. There shall
              be no refund, if the Client fails to join at the commencement of
              the tour, or joins the tour later or leaves the tour before
              completion. It be noted that for all purposes, it shall be the
              responsibility of the Client to reach the place of commencement of
              the tour and register with the representative of Mango Holidays
              (India) Pvt. Ltd. at the appointed place, date and time. The
              Client/s who do not travel throughout the tour shall under no
              circumstances be entitled to any refund. In case a Client along
              with his companions is compelled to discontinue the tour due to
              any reason whatsoever including injury, illness, death or loss of
              passport or any travel documents in such or similar cases, no
              claim shall be entertained for refund of money paid for unutilized
              services. If the client decides to leave the tour before
              completion then he has to inform about his intentions in writing
              either by sending email on MHIPL’s official email address or by
              issuing letter addressed to the tour manager. Further if the
              client decides to leave the tour then he cannot rejoin / continue
              the tour and he will not be entitled for any refund.
            </li>
            <li>
              The client’s signature on the booking form and / or paying the
              booking amount to MHIPL confirms the client’s acceptance in
              totality of the terms and conditions contained herein. In case of
              one or more but not all passengers signing the booking form, it
              shall be deemed that the others whose name / s are mentioned in
              the booking form have duly authorized the client who has signed
              such a booking form on their behalf to accept such terms and
              conditions mentioned herein in totality.
            </li>
            <li>
              Each and every client booked on the tour of Mango Holidays (India)
              Pvt. Ltd has to inform Mango Holidays (India) Pvt. Ltd about their
              own pre-existing disease /s if any at the time of booking the
              tour. Failing which it may have an adverse effect on his / her
              travel insurance policy as well as on tour itinerary / sightseeing
              program.
            </li>
            <li>
              Mango Holidays (India) Pvt. Ltd. reserves the right to publish the
              Client’s photograph or group photographs taken during the tour on
              their website or brochures or on social media.
            </li>
            <li>Tours are subject to RBI / Government of India approval.</li>
            <li>
              Closed groups / Jain special tour / any group having less than 35
              passengers will be merged with any other available tour, which
              will subsequently lead to a change in itinerary and other program.
              MHIPL will try to provide the preferred food options, however
              there was / is no commitment as such at any point of time by MHIPL
              about making available such food. Further in case of merging of
              such closed group / Jain special tour with the other tour, the
              client has to accommodate himself to the new itinerary.
            </li>
          </ul>
        </div>

        <div className="print-button">
          <button className="btn-c" onClick={handlePrint}>
            <p>Print</p>
          </button>
        </div>
      </section>
    </>
  );
};

export default TermsConditions;
